import React, { useState } from 'react';
import useAuth from '../Auth/hook_useAuth';
import Api from '../Auth/Api';
import { Toast, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import loginAnimation from '../assets/animations/login-animation.json';
import { useAjustes } from '../Context/AjustesContext';
import '../styles/login.css';

function Login() {
    const navigate = useNavigate();
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [codigo, setCodigo] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [plataforma, setPlataforma] = useState('publica');
    const { signin } = useAuth();
    const { ajustes } = useAjustes();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await Api.post("/login", { codigo, password });
            signin({ token: response.data.token, nome_completo: response.data.nome_completo, nivel: response.data.nivel, foto: response.data.foto, primeiro_login: response.data.primeiro_login, pesquisa_satisfacao: response.data.pesquisa_satisfacao, concluiu_aula: response.data.concluiu_aula }, true);

            if (response.data.primeiro_login === 0 || response.data.primeiro_login === null) {
                navigate("/primeiro-login");
            } else if (
                response.data.nivel !== 'Administrador' &&
                response.data.primeiro_login !== null &&
                response.data.concluiu_aula === true &&
                (response.data.pesquisa_satisfacao === null || response.data.pesquisa_satisfacao === undefined)
            ) {
                navigate("/pesquisa-satisfacao");
            } else {
                if (response.data.nivel === 'Aluno') {
                    navigate("/aluno/dashboard");
                } else {
                    navigate("/dashboard");
                }
            }
            localStorage.setItem("primeiro_login", response.data.primeiro_login);

        } catch (error) {
            setToast({ header: 'Ocorreu um erro!', body: error.response.data.message })
            setShowToast(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header>
                    <strong className="mr-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <div className="login-wrapper" style={{ background: `linear-gradient(135deg, ${ajustes.cor_primaria} 0%, ${ajustes.cor_secundaria} 100%)` }}>
                {/* Background Decorative Elements */}
                <div className="bg-decoration">
                    <div className="shape shape-1"></div>
                    <div className="shape shape-2"></div>
                    <div className="shape shape-3"></div>
                    <div className="floating-particles">
                        {[...Array(6)].map((_, i) => (
                            <div key={i} className={`particle particle-${i + 1}`}></div>
                        ))}
                    </div>
                </div>

                <div className="login-container">
                    <div className="login-grid">
                        {/* Left Panel - Animation */}
                        <div className="login-panel left-panel" style={{ background: `linear-gradient(135deg, ${ajustes.cor_primaria} 0%, ${ajustes.cor_secundaria} 100%)` }}>
                            <div className="panel-content">
                                <span className="platform-badge">
                                    <i className="fas fa-globe"></i> Plataforma Pública
                                </span>
                                <div className="animation-wrapper">
                                    <Lottie
                                        animationData={loginAnimation}
                                        loop={true}
                                        className="login-animation"
                                    />
                                </div>
                                <div className="welcome-text">
                                    <h2 className="welcome-title">Bem-vindo de volta!</h2>
                                    <p className="welcome-subtitle">
                                        Acesse sua conta e continue sua jornada de aprendizado
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Right Panel - Form */}
                        <div className="login-panel right-panel">
                            <div className="form-container">
                                <div className="platform-switcher">
                                    <button
                                        type="button"
                                        className={`platform-option ${plataforma === 'publica' ? 'active' : ''}`}
                                        onClick={() => setPlataforma('publica')}
                                        style={plataforma === 'publica' ? { background: ajustes.cor_primaria, color: '#fff' } : {}}
                                    >
                                        <i className="fas fa-globe me-1"></i> Órgãos Públicos
                                    </button>
                                    <button
                                        type="button"
                                        className={`platform-option ${plataforma === 'privada' ? 'active' : ''}`}
                                        onClick={() => {
                                            setPlataforma('privada');
                                            window.location.href = 'https://private.treinamentosmfj.com.br/';
                                        }}
                                        style={plataforma === 'privada' ? { background: ajustes.cor_secundaria, color: '#fff' } : {}}
                                    >
                                        <i className="fas fa-lock me-1"></i> Empresas Privadas
                                    </button>
                                </div>

                                <div className="form-header">
                                    <div className="logo-container">
                                        {ajustes.logo ? (
                                            <img
                                                src={ajustes.logo}
                                                alt={ajustes.titulo || "Logo"}
                                                className="brand-logo"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "./../assets/logo.png";
                                                }}
                                            />
                                        ) : (
                                            <img
                                                src="./../assets/logo.png"
                                                alt="Logo"
                                                className="brand-logo"
                                            />
                                        )}
                                    </div>
                                    <p className="form-subtitle">Digite suas credenciais para acessar</p>
                                </div>

                                <form onSubmit={handleSubmit} className="login-form">
                                    <div className="input-group">
                                        <div className="input-wrapper">
                                            <i className="fas fa-user input-icon"></i>
                                            <input
                                                type="text"
                                                className="form-input"
                                                placeholder="Matrícula"
                                                value={codigo}
                                                onChange={e => setCodigo(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="input-group">
                                        <div className="input-wrapper">
                                            <i className="fas fa-lock input-icon"></i>
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-input"
                                                placeholder="Senha"
                                                value={password}
                                                onChange={e => setPassword(e.target.value)}
                                                required
                                            />
                                            <button
                                                type="button"
                                                className="password-toggle"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="form-options">
                                        <label className="checkbox-wrapper">
                                            <input type="checkbox" className="checkbox-input" id="rememberMe" />
                                            <span className="checkbox-custom"></span>
                                            <span className="checkbox-label">Lembrar-me</span>
                                        </label>
                                        <button
                                            type="button"
                                            onClick={() => navigate("/recuperar")}
                                            className="forgot-password"
                                        >
                                            Esqueceu a senha?
                                        </button>
                                    </div>

                                    <button
                                        type="submit"
                                        className="submit-btn"
                                        disabled={isLoading}
                                        style={{ background: ajustes.cor_primaria }}
                                    >
                                        <span className="btn-content">
                                            {isLoading ? (
                                                <>
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        className="btn-spinner"
                                                    />
                                                    Entrando...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-sign-in-alt me-2"></i>
                                                    Entrar
                                                </>
                                            )}
                                        </span>
                                        <div className="btn-ripple"></div>
                                    </button>
                                </form>

                                <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                                    <button
                                        type="button"
                                        onClick={() => navigate("/validar-certificado")}
                                        className="forgot-password"
                                        style={{ fontSize: '0.95rem' }}
                                    >
                                        <i className="fas fa-certificate me-1"></i>
                                        Validar Certificado
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="version-badge">
                    <span>v{process.env.REACT_APP_API_VERSION}</span>
                </div>
            </div>
        </>
    );
}

export default Login;